import { useState } from 'react'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { Monitor, Smartphone } from 'lucide-react'
import { authApi, describeError, type Session } from '@/lib/auth'
import { formatDateTime } from '@/lib/format'
import { cx } from '@/lib/cx'
import layer from './SettingsLayer.module.css'
import styles from './DevicesSection.module.css'

export function DevicesSection() {
  const qc = useQueryClient()
  const sessions = useQuery({ queryKey: ['sessions'], queryFn: authApi.sessions })
  const [error, setError] = useState<string | null>(null)
  const revoke = useMutation({
    mutationFn: authApi.revokeOtherSessions,
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['sessions'] }),
    onError: (err) => setError(describeError(err).message),
  })
  const list = [...(sessions.data ?? [])].sort((a, b) => Number(b.current) - Number(a.current) || b.last_seen_at.localeCompare(a.last_seen_at))
  const others = list.filter((s) => !s.current).length

  return (
    <section>
      <div className={layer.divider} />
      <h2 className={layer.subTitle}>Активные сеансы</h2>
      <p className={layer.text}>Устройства, где выполнен вход. Незнакомое — выйдите на остальных и смените пароль.</p>
      {sessions.isPending ? <p className={layer.text}>Загружаем…</p> : null}
      {sessions.isError ? <p className={cx(layer.text, styles.error)}>Не удалось загрузить список устройств.</p> : null}
      <ul className={styles.list}>
        {list.map((s) => <SessionRow key={s.id} session={s} />)}
      </ul>
      {others > 0 ? (
        <div className={layer.buttonRow}>
          <button type="button" className={cx(layer.button, layer.buttonDanger)} disabled={revoke.isPending} onClick={() => revoke.mutate()}>
            Выйти на других устройствах ({others})
          </button>
        </div>
      ) : null}
      {error ? <p className={cx(layer.text, styles.error)} role="alert">{error}</p> : null}
    </section>
  )
}

function SessionRow({ session }: { session: Session }) {
  const mobile = /android|iphone|ipad|mobile/i.test(session.device)
  return (
    <li className={cx(styles.row, session.current && styles.rowCurrent)}>
      <span className={styles.icon} aria-hidden="true">{mobile ? <Smartphone size={22} /> : <Monitor size={22} />}</span>
      <div className={styles.info}>
        <span className={styles.device}>
          {session.device || 'Неизвестное устройство'}
          {session.current ? <span className={styles.badge}>Это устройство</span> : null}
        </span>
        <span className={styles.meta}>IP {session.ip || '—'} · был в сети {formatDateTime(new Date(session.last_seen_at))}</span>
      </div>
    </li>
  )
}
